<template>
  <div class="tv">
    <div class="tv-container">
      <div class="tv-wrapper" ref="refTvWrapper">
        <router-link
          v-for="(tag, index) in visitedViews"
          class="tv-item"
          :class="{ active: isActive(tag) }"
          :key="index"
          :to="{ path: tag.path, query: tag.query }"
        >
          <TagTitle :title="tag.meta.title" :tag="tag" @toLastView="toLastView" />
          <span v-if="!isAffixTags(tag)" class="tv-item-close" @click.prevent="closeSelectedTag(tag)">
            <SvgIcon icon="ant-design:close-circle-outlined" />
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import TagTitle from './TagTitle.vue';

import { routes } from '@/router';
import { mapState, mapMutations } from "vuex";
import { resolve } from 'path-browserify';

export default {
  components: {
    TagTitle
  },
  data(){
    return {
    }
  },
  computed: {
    ...mapState('tagsView', ['visitedViews']),
  },
  mounted(){
    this.initTagsView();
  },
  watch: {
    '$route.path': {
      // immediate: true,
      deep: true,
      handler(){
        this.addTags();
        this.scrollCurrentTabIntoView();
      },
    }
  },
  methods: {
    ...mapMutations('tagsView', ['addView', 'deleteView']),
    // 让激活的tab滚动到视口内
    scrollCurrentTabIntoView(){
      setTimeout(() => {
        const eleActiveLink = this.$refs.refTvWrapper.querySelector('.tv-item.active');
        if (eleActiveLink) eleActiveLink.scrollIntoView();
      }, 10)
    },
    // 判断是否为当前激活的tag
    isActive(tag){return tag.path === this.$route.path;},
    // 当前路由是否是固定的标签导航
    isAffixTags(tag){return tag.meta.affixTagView;},
    // 初始化标签导航列表
    initTagsView(){
      const affixTags = this.filterAffixTags(routes);
      affixTags.forEach((tag) => this.addView(tag)); // 默认添加具有 affixTagView 元信息的路由标签
      this.addTags(); // 添加当前路由标签
    },
    // 添加路由到标签导航中，只有有name属性的路由才去保存
    addTags(){
      if (this.$route.name) this.addView(this.$route);
    },
    // 删除选中的路由
    closeSelectedTag(tag){
      this.deleteView(tag);
      // 如果删掉了自己，需要导航当前列表中的最后一个
      if (this.isActive(tag)) this.toLastView(tag);
    },
    // 跳转列表中的最后一个路由
    toLastView(tag){
      const {visitedViews} = this;
      // 从剩下集合中得到最后⼀个路由 tag
      const lastView = visitedViews[visitedViews.length - 1];
      if (lastView) {
        this.$router.push(lastView).catch(() => {});
        return;
      }
      // 如果刚刚删除的正是home 就重定向回home
      this.$router.push(tag.path === '/home' ? '/home' : '/').catch(() => {});
    },
    // 计算哪些tag应该默认固定展示在列表中
    filterAffixTags(routes, basePath='/'){
      const tags = [];
      for (let route of routes) {
        // 检查路由是否具有 affixTagView 元信息并添加到 tags
        if (route.meta?.affixTagView) {
          tags.push({
            name: route.name,
            path: resolve(basePath, route.path),
            query: route.query,
            meta: { ...route.meta }
          });
        }
        // 递归处理子路由
        if (route.children) tags.push(...this.filterAffixTags(route.children, route.path));
      }
      return tags;
    },
  }
}


</script>

<style scoped lang="scss" src="./index.scss">
</style>